import { Alert, AlertIcon } from '@chakra-ui/react'

import theme from 'theme'

import type { ReactNode } from 'react'

type Props = {
  text?: string
  children?: ReactNode
}

const NotificationError = ({ text, children }: Props) => {
  return (
    <Alert
      status="error"
      background={theme.colors.red['50']}
      color={theme.baseColors.text.default}
      textStyle="body2"
      borderRadius={theme.radii.base}
      flexDirection="unset"
    >
      <AlertIcon color={theme.baseColors.danger.main} />
      {children ?? text ?? ''}
    </Alert>
  )
}

export default NotificationError
